import { createI18n } from 'vue-i18n'
import { configure } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import i18nData from './i18nData'

configure({
  generateMessage: localize('en', {
    messages: {
      required: 'This field is required.',
      required_unless: 'Either {field} or 0:{target} is required'
    }
  }),
});

// Fetch language preference from localStorage
const savedLanguage = localStorage.getItem('language-preference') || 'en'
export default createI18n({
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: i18nData,
})